<div class="content">
  <div class="row no-gutters justify-content-between align-items-center">
    <div class="month-label">{{ month }}</div>
    <div class="btn-group">
      <button class="tertiary-small-icon" (click)="previous()">
        <i-feather name="chevron-left" class="icon"></i-feather>
      </button>
      <button class="tertiary-small-icon" (click)="next()">
        <i-feather name="chevron-right" class="icon"></i-feather>
      </button>
    </div>
  </div>
  <section class="body">
    <div
      class="weekday subheading1 llblue60"
      *ngFor="let s of ['S', 'M', 'T', 'W', 'T', 'F', 'S']; let i = index"
      [ngClass]="{ active: isWeekdayActive(i) }"
      (click)="selectWeekday(i)"
    >
      {{ s }}
    </div>
    <div
      class="date"
      *ngFor="let date of dates"
      (click)="select(date)"
      [ngClass]="{ toggled: isSelected(date), other: isThisMonth(date) }"
    >
      {{ date.getDate() }}
    </div>
  </section>
</div>
